import type { RepositoryLoadedElementData } from '@bizzdesign/shared/models';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const fromRepoStatusUiEvents = eventGroup({
  source: 'From Repo Status UI',
  events: {
    failedToCheckStatus: type<void>(),
    convertToMockExternalSuccess: type<void>(),
    startedCheckStatus: type<{ data: RepositoryLoadedElementData[] }>(),
  },
});

export const fromRepoStatusAPIEvents = eventGroup({
  source: 'From Repo Status API',
  events: {
    updateFromRepoInModeler: type<{ data: RepositoryLoadedElementData[] }>(),
  },
});
